$(function () {
	var $slideshow = $('#slideshow ul');
	var $frames = $slideshow.children('li');

	var $buttons = $('#pagination-list');
	$buttons.addClass('buttons');

	var interval;

	var delay = 8000;
	var fadeTime = 1000;

	var nextFrame = function () {
		var $currentButton = $buttons.children('li.selected');
		var $nextButton;
		if ($currentButton.is('li.page:last-child')) $nextButton = $buttons.children('li.page').first();
		else $nextButton = $currentButton.next('li.page');

		$nextButton.triggerHandler('select');
	};
	var timeout;
	var interval;
	if ($frames.length > 1) {

		$frames.each(function (i, element) {
			$(element).addClass("slide");
			if (i == 0)
				$slideshow.height($(element).height());
			var li = $("<li></li>");
			$buttons.append(
					li
					.addClass("page")
					.text(i + 1)
					.data('frame', $frames.eq(i))
					.bind('select', function () {
						var $t = $(this);
						if ($t.hasClass('selected')) return;

						var $thisFrame = $t.data('transitioning', true).data('frame');
						var $selectedFrame = $buttons.children('li.selected').data('frame');

						if ($buttons.data('transitioning')) {
							clearTimeout(timeout);
							timeout = setTimeout(function () { $t.triggerHandler('select'); }, 10);
							return;
						}
						$buttons.data('transitioning', true);

						$buttons.children('li.page').removeClass('selected');
						$t.addClass('selected');
						$selectedFrame.css({ display: 'block', 'z-index': 3 });
						$thisFrame.css({ display: 'block', 'z-index': 2 });
						$slideshow.height($selectedFrame.height());

						$selectedFrame.fadeOut(fadeTime, function () {
							$thisFrame.css({ 'z-index': 3 });
							$buttons.data('transitioning', false);
						});
					})
					.css({
						cursor: 'pointer'
					})
					.click(function (e) {
						e.stopImmediatePropagation();
						clearInterval(interval);
						$(this).triggerHandler('select');
						interval = setInterval(nextFrame, delay);
					})
			/*
			.mouseover( function() {
			clearInterval( interval );
			$(this).triggerHandler( 'select' );	 
			} )
			.mouseout( function() {
			clearInterval( interval );
			interval = setInterval( nextFrame, delay );
			} )
			*/
				);
		});

		$frames.css({ 'z-index': 2 }).slice(1).hide();

		$buttons.find('li.page').first().addClass('selected');

		interval = setInterval(nextFrame, delay);
	}
});